import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import MemberView from "@/views/MGT/member/components/member-view.vue";
import MemberAdd from "@/views/MGT/member/components/member-add.vue";
import MemberBatchAdd from "@/views/MGT/member/components/member-batch-add.vue";
import MemberDetail from "@/views/MGT/member/components/member-detail.vue";
import MemberImportandExport from "@/views/MGT/member/components/member-importand-export.vue";
import ProActionMore from "@/components/pro-common/pro-action/pro-action-more.vue";
import OverflowTooltipText from "@/components/Common/overflow-tooltip-text.vue";
import { initPurposeHeight } from "@/utils/util.js";
import { unbindMFA } from "@/service/unit.js";
import { renderTableTitle } from "@/utils/render.jsx";
import { memberPage, recoverMember, quitMember, userDelete, disableMember, enableMember } from "@/service/structure.js";
export default {
  name: "member-list",
  components: {
    MemberAdd,
    MemberBatchAdd,
    MemberDetail,
    MemberImportandExport,
    MemberView
  },
  props: {
    node: {
      type: Object,
      default() {
        return {};
      }
    },
    searchValue: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      addVisible: false,
      batchAddVisible: false,
      detail: {
        visible: false,
        row: {}
      },
      exportVisible: false,
      retValTable: {},
      tableSelectList: [],
      statusList: [{
        // lg: 在职
        name: $t("fj1g2", "在职"),
        value: "10"
      }, {
        // lg: 禁用
        name: $t("lb5z2", "禁用"),
        value: "50"
      }, {
        // lg: 离职
        name: $t("ler52", "离职"),
        value: "99"
      }],
      config: {
        map: {
          dataPath: "retVal.datas",
          message: "msg",
          totalPath: "retVal.totalRows"
        },
        ref: "proTable",
        format: {
          formatCurrent: "(page.current - 1) * page.pageSize"
        },
        request: async search => {
          if (this.node.orgId) {
            let params = {
              ...search,
              orgId: this.node.orgId,
              search: this.searchValue
            };
            let {
              data
            } = await memberPage(params);
            if (data && data.result === 0) {
              this.tableSelectList = [];
              this.retValTable = data.retVal;
              return data;
            }
          }
        },
        search: {
          value: {
            status: "10,50"
          }
        },
        table: {
          stripe: false,
          "show-summary": false,
          "row-class-name": row => {
            return row.status === 50 ? "table_row_off" : "";
          },
          height: window.innerHeight - 284,
          border: false
        },
        page: {
          "show-elevator": false
        },
        hide: {
          search: true,
          toolBar: true
        }
      }
    };
  },
  computed: {
    _buttonShow() {
      return this.tableSelectList.length > 0;
    },
    isAdmin() {
      return this.$store.state.user.userInfo.isAdmin === "T";
    },
    _columns() {
      const h = this.$createElement;
      return [{
        type: "selection",
        width: 52,
        align: "center",
        fixed: "left",
        notShowTable: this.$store.state.user.userInfo.isAdmin !== "T"
      }, {
        // lg: 姓名
        title: $t("fqmy2", "姓名"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userName",
        notShowSearch: true,
        notShowForm: true,
        tooltip: true,
        fixed: "left",
        width: 170
      }, {
        // lg: 部门
        title: $t("pgxs2", "部门"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        notShowSearch: true,
        notShowForm: true,
        width: 200,
        renderTable: (h, {
          row
        }) => {
          let names = [];
          let hoverTitle = [];
          row.organizations.map(v => {
            if (v.name) {
              let arr = v.name.split("/");
              names.push(arr[arr.length - 1]);
            }
            hoverTitle.push(v.name);
          });
          if (names.length > 0) {
            return h("Tooltip", {
              "style": {
                width: "100%",
                marginTop: "5px"
              },
              "attrs": {
                "max-width": 200,
                "content": hoverTitle.join(" ; "),
                "transfer": true
              }
            }, [h("span", {
              "style": {
                ...this.colorTableForStatus(row),
                ...this.ellipsisTable()
              }
            }, [names.join(" ; ")])]);
          } else {
            return h("span", [names]);
          }
        }
      }, {
        // lg: 手机
        title: $t("haa72", "手机"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "mobile",
        // align: "right",
        minWidth: 100,
        notShowSearch: true,
        notShowForm: true,
        tooltip: true
      }, {
        // lg: 邮箱
        title: $t("padf2", "邮箱"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userEmail",
        notShowSearch: true,
        notShowForm: true,
        tooltip: true,
        minWidth: 100
      }, {
        // lg: 工号
        title: $t("gfjm2", "工号"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userNumber",
        notShowSearch: true,
        notShowForm: true,
        tooltip: true,
        minWidth: 100
      }, {
        // lg: 用户代码
        title: $t("f6ql714", "用户代码"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "userCode",
        notShowSearch: true,
        notShowForm: true,
        tooltip: true,
        width: 120
      }, {
        // lg: 状态
        title: $t("k1e32", "状态"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        key: "status",
        notShowSearch: true,
        notShowForm: true,
        width: 120,
        render: (h, {
          row
        }) => {
          const statusObj = {
            10: {
              text: $t("fj1g2", "在职"),
              className: "bg-[#E3FFF1] text-[#05A660] p-2"
            },
            // lg: 在职
            50: {
              text: $t("lb5z2", "禁用"),
              className: "bg-[#FFE6E6] text-[#E63535] p-2"
            },
            // lg: 禁用
            99: {
              text: $t("ler52", "离职"),
              className: "bg-[#FFF8E6] text-[#FF8800] p-2"
            } // lg: 离职
          };
          const info = statusObj[row.status] || {
            text: "—",
            className: ""
          };
          // 保留状态标签的自适应宽度，文字超过单元格时再显示省略号和 Tooltip。
          return h(OverflowTooltipText, {
            props: {
              text: info.text,
              maxWidth: 300,
              textClass: info.className,
              tooltipStyle: {
                display: "block",
                width: "100%",
                minWidth: 0
              },
              textStyle: {
                width: "fit-content",
                maxWidth: "100%",
                boxSizing: "border-box"
              }
            }
          });
        }
      }, {
        // lg: 操作
        title: $t("hkxb2", "操作"),
        renderHeader: (h, {
          column
        }) => {
          // 使用列标题保持翻译一致，并按实际宽度决定是否显示提示。
          return renderTableTitle(column.title, column, h);
        },
        align: "center",
        width: 120,
        fixed: "right",
        render: (itemh, {
          row
        }) => {
          let buttons = [];
          let edit = {
            icon: "icon-a-edit-12x",
            type: "edit",
            click: () => {
              this.onOpenEdit(row);
            }
          };
          let view = {
            icon: "icon-yanjing",
            type: "view",
            click: () => {
              this.onOpenView(row);
            }
          };
          let recover = {
            // lg: 恢复
            title: $t("gvsb2", "恢复"),
            click: () => {
              this.onRecover(row.userId);
            }
          };
          let resign = {
            // lg: 离职
            title: $t("ler52", "离职"),
            poptip: {
              // lg: 确定离职
              title: $t("fku4t94", "确定离职") + "？"
            },
            click: () => {
              this.onResign(row.userId);
            }
          };
          let off = {
            // lg: 禁用
            title: $t("lb5z2", "禁用"),
            poptip: {
              // lg: 禁用后，${row.userName}将无法登录企业。
              title: $t("bk1z57r", "\u7981\u7528\u540E\uFF0C${row.userName}\u5C06\u65E0\u6CD5\u767B\u5F55\u4F01\u4E1A\u3002", {
                "row.userName": row.userName
              })
            },
            click: () => {
              this.onOff(row.userId);
            }
          };
          let open = {
            // lg: 启用
            title: $t("eymx2", "启用"),
            click: () => {
              this.onOpen(row.userId);
            }
          };
          let rowDelete = {
            // lg: 删除
            title: $t("eslg2", "删除"),
            poptip: {
              // lg: 删除后，${row.userName}的企业信息记录将完全被清除。
              title: $t("cridycx", "\u5220\u9664\u540E\uFF0C${row.userName}\u7684\u4F01\u4E1A\u4FE1\u606F\u8BB0\u5F55\u5C06\u5B8C\u5168\u88AB\u6E05\u9664\u3002", {
                "row.userName": row.userName
              })
            },
            click: () => {
              this.onDeletes(row.userId);
            }
          };
          // 解绑MFA
          let unbindMfa = {
            title: $t("d47io65", "解绑MFA"),
            hideMoreTip: true,
            click: async () => {
              this.$Modal.warning({
                title: $t("jwcjyd4", "风险提示"),
                width: 520,
                closable: true,
                render: () => {
                  let {
                    unitName
                  } = this.$store.state.user.userInfo;
                  return h("Alert", {
                    "attrs": {
                      "show-icon": true,
                      "type": "warning"
                    }
                  }, [$t("a1v0c76", "尊敬的用户："), h("span", {
                    "slot": "icon"
                  }, [h("Icon", {
                    "attrs": {
                      "type": "ios-bulb-outline"
                    }
                  })]), h("span", {
                    "slot": "desc"
                  }, [h("div", {
                    "style": "display: flex; flex-direction: column; gap: 5px"
                  }, [h("span", {
                    "style": "text-indent: 32px;word-break:break-all"
                  }, [$t("nvgpo51s", "\u6B64\u64CD\u4F5C\u5C06\u89E3\u9664\u7528\u6237 ${row.userName || \"\"} \u7684\u591A\u91CD\u8BA4\u8BC1\u7ED1\u5B9A\u3002\u89E3\u9664\u540E\uFF0C\u5176\u8D26\u6237\u5B89\u5168\u6027\u5C06\u964D\u4F4E\uFF0C\u76F4\u5230\u5176\u91CD\u65B0\u7ED1\u5B9AMFA\u3002", {
                    "row.userName || \"\"": row.userName || ""
                  })]), h("div", {
                    "style": "display: flex; justify-content: end"
                  }, [h("span", [`${$t('s9vecn5', '当前企业：')}${unitName}`])])])])]);
                },
                okText: $t("7q7myq7", "解除绑定MFA"),
                cancelText: "     ",
                onOk: async () => {
                  let {
                    data: {
                      result
                    }
                  } = await unbindMFA({
                    userId: row.userId
                  });
                  if (result === 0) {
                    this.$Message.success($t("hx53z14", "解绑成功"));
                    this.onSearchStatr();
                  }
                }
              });
            }
          };
          if (this.isAdmin) {
            buttons.push(edit);
            if (row.status === 99) {
              buttons.push(recover);
            }
            if (row.status === 10) {
              buttons.push(resign);
            }
            if (row.status === 50) {
              buttons.push(open);
            }
            if (row.status === 10) {
              buttons.push(off);
            }
            buttons.push(rowDelete);
            if (row.isMfaBound === "T") {
              buttons.push(unbindMfa);
            }
          } else {
            buttons.push(view);
          }
          return h(ProActionMore, {
            "attrs": {
              "data": buttons
            }
          });
        }
      }];
    }
  },
  watch: {
    "node.orgId": function () {
      this.onSearchStatr();
      if (!this.config.table.height) {
        initPurposeHeight(this, {
          form: this.config.table,
          params: "height"
        }, "member_list", ["mmeber_list_head"]);
      }
    },
    searchValue() {
      this.onSearchStatr();
    }
  },
  methods: {
    colorTableForStatus(row) {
      return {
        color: row.status === 50 ? "rgba(0,0,0,0.3)" : ""
      };
    },
    ellipsisTable() {
      return {
        display: "inline-block",
        width: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      };
    },
    onSearch() {
      this.$refs[this.config.ref].fetch();
    },
    onSearchStatr() {
      this.$refs[this.config.ref].searchAction();
    },
    onOpenAdd() {
      this.addVisible = true;
    },
    onOpenBatchAdd() {
      this.batchAddVisible = true;
    },
    onOpenEdit(row) {
      this.detail.row = {
        ...row
      };
      this.detail.visible = true;
    },
    onOpenView(row) {
      this.$refs.memberViewRef.open(row);
    },
    onOpenExport() {
      this.exportVisible = true;
    },
    async onRecover(userId) {
      const params = {
        userIds: userId
      };
      let {
        data
      } = await recoverMember(params);
      if (data && data.result === 0) {
        // lg: 恢复成功
        this.$Message.success($t("cj5nei4", "恢复成功"));
        this.onSearch();
      }
    },
    async onResign(userId) {
      let ids = "";
      if (userId) {
        ids = userId;
      } else {
        let selects = this.tableSelectList;
        let boo = selects.some(v => v.status === 0 || v.status === 99);
        if (boo) {
          // lg: 只有 “在职” 和 “禁用” 才能离职
          this.$Message.warning($t("gk2e9bj", "只有 “在职” 和 “禁用” 才能离职"));
          return;
        }
        ids = selects.map(v => v.userId).join(",");
      }
      const params = {
        userIds: ids
      };
      let {
        data
      } = await quitMember(params);
      if (data && data.result === 0) {
        // lg: 操作成功
        this.$Message.success($t("d1spvi4", "操作成功"));
        this.onSearch();
      }
    },
    /*
     ** 删除成员
     */
    async onDeletes(userId) {
      let ids = "";
      if (userId) {
        ids = userId;
      } else {
        let selects = this.tableSelectList;
        ids = selects.map(item => item.userId).join(",");
      }
      const params = {
        userIds: ids,
        orgIds: this.node.orgId
      };
      let {
        data
      } = await userDelete(params);
      if (data && data.result === 0) {
        // lg: 删除成功
        this.$Message.success($t("azeh8z4", "删除成功"));
        let proTableRef = this.$refs.proTable;
        if ((proTableRef.proData.length === 1 || proTableRef.proData.length === this.tableSelectList.length) && proTableRef.page.current > 1) {
          proTableRef.page.current -= 1;
        }
        this.onSearch();
      }
    },
    onChangeStatus(arr) {
      if (arr.length === 0) {
        // lg: 至少选择一项
        this.$Message.warning($t("5lfmd36", "至少选择一项"));
        let status = this.config.search.value.status;
        this.config.search.value.status = "";
        this.$nextTick(() => {
          this.config.search.value.status = status;
        });
        return;
      }
      this.config.search.value.status = arr.join(",");
      this.onSearchStatr();
    },
    async onOff(userId) {
      const params = {
        userIds: userId
      };
      let {
        data
      } = await disableMember(params);
      if (data && data.result === 0) {
        // lg: 禁用成功
        this.$Message.success($t("ftc7864", "禁用成功"));
        this.onSearch();
      }
    },
    async onOpen(userId) {
      const params = {
        userIds: userId
      };
      let {
        data
      } = await enableMember(params);
      if (data && data.result === 0) {
        // lg: 启用成功
        this.$Message.success($t("b3vqjs4", "启用成功"));
        this.onSearch();
      }
    },
    onTableSelectList(selection) {
      this.tableSelectList = selection;
    }
  }
};